export default __webpack_public_path__ + "static/media/check-light.d7dd55bb.svg";